import React from "react";
import { useDrawer } from "@/context/DrawerContext";
import { usePabSession } from "@/hooks/usePabSession";
import { MultiHubDrawer } from "@/pages/dashboard/components/MultiHubDrawer";
import { AppDrawer } from "@/components/AppDrawer";
import { Text } from "@/components/Typography";

/**
 * Global MultiHubDrawer component that can be opened from anywhere in the app
 * Uses DrawerContext for state management and PabSessionContext for session data
 */
export const UseMultiHubDrawer: React.FC = () => {
  const {
    isMultiHubDrawerOpen,
    multiHubDrawerDefaultTab,
    closeMultiHubDrawer,
  } = useDrawer();
  const { session, isLoading } = usePabSession();

  // Don't render anything if drawer is closed
  if (!isMultiHubDrawerOpen) {
    return null;
  }

  // If session exists, use the full MultiHubDrawer
  if (session) {
    return (
      <MultiHubDrawer
        isOpen={isMultiHubDrawerOpen}
        onClose={closeMultiHubDrawer}
        session={session}
        defaultTab={multiHubDrawerDefaultTab}
      />
    );
  }

  // If no session but drawer is open, show empty state
  return (
    <AppDrawer isOpen={isMultiHubDrawerOpen} onClose={closeMultiHubDrawer} maxWidth="22.5rem" showCloseButton={true}>
      <div className="w-full p-4">
        {isLoading ? (
          <Text>Loading session...</Text>
        ) : (
          <Text>No active session found. Please start a session to view messages and sessions.</Text>
        )}
      </div>
    </AppDrawer>
  );
};

